<div class="container-fluid">
  <!--<div *ngIf="loading; else loaded">
    <app-loading></app-loading>
  </div>-->

  <!-- Title with Icon -->
  <h1 class="h3 mb-2 text-gray-800">
    <i class="fas fa-book-open mr-2"></i>{{ menu.bookAnalayticsI18n }}
  </h1>

  <!-- Description -->
  <p class="lead mb-4">This module provides insights into book analytics, allowing you to view detailed information about books categorized by genre, author, and publisher. Analyze trends and make data-driven decisions with comprehensive charts and visualizations.</p>

  <!-- DataTales Example -->
  <div class="card shadow mb-4">
    <div class="card-body">
      <ngx-charts-bar-vertical
        [view]="view"
        [scheme]="'cool'"
        [results]="bookByCategories"
        [gradient]="gradient"
        [xAxis]="showXAxis"
        [yAxis]="showYAxis"
        [legend]="showLegend"
        [showXAxisLabel]="showXAxisLabel"
        [showYAxisLabel]="showYAxisLabel"
        [xAxisLabel]="xAxisLabel1"
        [yAxisLabel]="yAxisLabel"
        (select)="onSelect($event)"
      ></ngx-charts-bar-vertical>

      <ngx-charts-bar-vertical
        [view]="view"
        [scheme]="'cool'"
        [results]="bookByAuthors"
        [gradient]="gradient"
        [xAxis]="showXAxis"
        [yAxis]="showYAxis"
        [legend]="showLegend"
        [showXAxisLabel]="showXAxisLabel"
        [showYAxisLabel]="showYAxisLabel"
        [xAxisLabel]="xAxisLabel2"
        [yAxisLabel]="yAxisLabel"
        (select)="onSelect($event)"
      ></ngx-charts-bar-vertical>

      <ngx-charts-bar-vertical
        [view]="view"
        [scheme]="'cool'"
        [results]="bookByPublishers"
        [gradient]="gradient"
        [xAxis]="showXAxis"
        [yAxis]="showYAxis"
        [legend]="showLegend"
        [showXAxisLabel]="showXAxisLabel"
        [showYAxisLabel]="showYAxisLabel"
        [xAxisLabel]="xAxisLabel3"
        [yAxisLabel]="yAxisLabel"
        (select)="onSelect($event)"
      ></ngx-charts-bar-vertical>
    </div>
  </div>
</div>
